/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Role$inboundSchema, Role$outboundSchema } from "./role.js";
export const MessageContentPieChartType = {
    PieChart: "pie_chart",
};
export const MessageContentFormSubmissionType = {
    FormSubmission: "form_submission",
};
export const MessageContentFormType = {
    Form: "form",
};
export const MessageContentBarChartType = {
    BarChart: "bar_chart",
};
export const MessageContentTextType = {
    Text: "text",
};
export const MessageContentFunctionResultType = {
    FunctionResult: "function_result",
};
export const MessageContentFunctionCallType = {
    FunctionCall: "function_call",
};
export const MessageContentBinaryType = {
    Binary: "binary",
};
export const MessageContentMetadataType = {
    Metadata: "metadata",
};
/** @internal */
export const MessageContentPieChartType$inboundSchema = z.nativeEnum(MessageContentPieChartType);
/** @internal */
export const MessageContentPieChartType$outboundSchema = MessageContentPieChartType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentPieChartType$;
(function (MessageContentPieChartType$) {
    /** @deprecated use `MessageContentPieChartType$inboundSchema` instead. */
    MessageContentPieChartType$.inboundSchema = MessageContentPieChartType$inboundSchema;
    /** @deprecated use `MessageContentPieChartType$outboundSchema` instead. */
    MessageContentPieChartType$.outboundSchema = MessageContentPieChartType$outboundSchema;
})(MessageContentPieChartType$ || (MessageContentPieChartType$ = {}));
/** @internal */
export const MessageContentPieChartData$inboundSchema = z.object({
    label: z.string(),
    value: z.number(),
});
/** @internal */
export const MessageContentPieChartData$outboundSchema = z.object({
    label: z.string(),
    value: z.number(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentPieChartData$;
(function (MessageContentPieChartData$) {
    /** @deprecated use `MessageContentPieChartData$inboundSchema` instead. */
    MessageContentPieChartData$.inboundSchema = MessageContentPieChartData$inboundSchema;
    /** @deprecated use `MessageContentPieChartData$outboundSchema` instead. */
    MessageContentPieChartData$.outboundSchema = MessageContentPieChartData$outboundSchema;
})(MessageContentPieChartData$ || (MessageContentPieChartData$ = {}));
export function messageContentPieChartDataToJSON(messageContentPieChartData) {
    return JSON.stringify(MessageContentPieChartData$outboundSchema.parse(messageContentPieChartData));
}
export function messageContentPieChartDataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentPieChartData$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentPieChartData' from JSON`);
}
/** @internal */
export const MessageContentPieChartChart$inboundSchema = z.object({
    title: z.string(),
    data: z.array(z.lazy(() => MessageContentPieChartData$inboundSchema)),
});
/** @internal */
export const MessageContentPieChartChart$outboundSchema = z.object({
    title: z.string(),
    data: z.array(z.lazy(() => MessageContentPieChartData$outboundSchema)),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentPieChartChart$;
(function (MessageContentPieChartChart$) {
    /** @deprecated use `MessageContentPieChartChart$inboundSchema` instead. */
    MessageContentPieChartChart$.inboundSchema = MessageContentPieChartChart$inboundSchema;
    /** @deprecated use `MessageContentPieChartChart$outboundSchema` instead. */
    MessageContentPieChartChart$.outboundSchema = MessageContentPieChartChart$outboundSchema;
})(MessageContentPieChartChart$ || (MessageContentPieChartChart$ = {}));
export function messageContentPieChartChartToJSON(messageContentPieChartChart) {
    return JSON.stringify(MessageContentPieChartChart$outboundSchema.parse(messageContentPieChartChart));
}
export function messageContentPieChartChartFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentPieChartChart$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentPieChartChart' from JSON`);
}
/** @internal */
export const MessageContentPieChartParameters$inboundSchema = z.object({});
/** @internal */
export const MessageContentPieChartParameters$outboundSchema = z.object({});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentPieChartParameters$;
(function (MessageContentPieChartParameters$) {
    /** @deprecated use `MessageContentPieChartParameters$inboundSchema` instead. */
    MessageContentPieChartParameters$.inboundSchema = MessageContentPieChartParameters$inboundSchema;
    /** @deprecated use `MessageContentPieChartParameters$outboundSchema` instead. */
    MessageContentPieChartParameters$.outboundSchema = MessageContentPieChartParameters$outboundSchema;
})(MessageContentPieChartParameters$ || (MessageContentPieChartParameters$ = {}));
export function messageContentPieChartParametersToJSON(messageContentPieChartParameters) {
    return JSON.stringify(MessageContentPieChartParameters$outboundSchema.parse(messageContentPieChartParameters));
}
export function messageContentPieChartParametersFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentPieChartParameters$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentPieChartParameters' from JSON`);
}
/** @internal */
export const MessageContentPieChart$inboundSchema = z.object({
    type: MessageContentPieChartType$inboundSchema,
    chart: z.lazy(() => MessageContentPieChartChart$inboundSchema),
    callId: z.string(),
    functionName: z.string().optional(),
    parameters: z.lazy(() => MessageContentPieChartParameters$inboundSchema),
});
/** @internal */
export const MessageContentPieChart$outboundSchema = z.object({
    type: MessageContentPieChartType$outboundSchema,
    chart: z.lazy(() => MessageContentPieChartChart$outboundSchema),
    callId: z.string(),
    functionName: z.string().optional(),
    parameters: z.lazy(() => MessageContentPieChartParameters$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentPieChart$;
(function (MessageContentPieChart$) {
    /** @deprecated use `MessageContentPieChart$inboundSchema` instead. */
    MessageContentPieChart$.inboundSchema = MessageContentPieChart$inboundSchema;
    /** @deprecated use `MessageContentPieChart$outboundSchema` instead. */
    MessageContentPieChart$.outboundSchema = MessageContentPieChart$outboundSchema;
})(MessageContentPieChart$ || (MessageContentPieChart$ = {}));
export function messageContentPieChartToJSON(messageContentPieChart) {
    return JSON.stringify(MessageContentPieChart$outboundSchema.parse(messageContentPieChart));
}
export function messageContentPieChartFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentPieChart$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentPieChart' from JSON`);
}
/** @internal */
export const MessageContentFormSubmissionType$inboundSchema = z.nativeEnum(MessageContentFormSubmissionType);
/** @internal */
export const MessageContentFormSubmissionType$outboundSchema = MessageContentFormSubmissionType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFormSubmissionType$;
(function (MessageContentFormSubmissionType$) {
    /** @deprecated use `MessageContentFormSubmissionType$inboundSchema` instead. */
    MessageContentFormSubmissionType$.inboundSchema = MessageContentFormSubmissionType$inboundSchema;
    /** @deprecated use `MessageContentFormSubmissionType$outboundSchema` instead. */
    MessageContentFormSubmissionType$.outboundSchema = MessageContentFormSubmissionType$outboundSchema;
})(MessageContentFormSubmissionType$ || (MessageContentFormSubmissionType$ = {}));
/** @internal */
export const MessageContentFormSubmission$inboundSchema = z.object({
    type: MessageContentFormSubmissionType$inboundSchema,
    callId: z.string(),
    functionName: z.string().optional(),
    result: z.any().optional(),
});
/** @internal */
export const MessageContentFormSubmission$outboundSchema = z.object({
    type: MessageContentFormSubmissionType$outboundSchema,
    callId: z.string(),
    functionName: z.string().optional(),
    result: z.any().optional(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFormSubmission$;
(function (MessageContentFormSubmission$) {
    /** @deprecated use `MessageContentFormSubmission$inboundSchema` instead. */
    MessageContentFormSubmission$.inboundSchema = MessageContentFormSubmission$inboundSchema;
    /** @deprecated use `MessageContentFormSubmission$outboundSchema` instead. */
    MessageContentFormSubmission$.outboundSchema = MessageContentFormSubmission$outboundSchema;
})(MessageContentFormSubmission$ || (MessageContentFormSubmission$ = {}));
export function messageContentFormSubmissionToJSON(messageContentFormSubmission) {
    return JSON.stringify(MessageContentFormSubmission$outboundSchema.parse(messageContentFormSubmission));
}
export function messageContentFormSubmissionFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentFormSubmission$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentFormSubmission' from JSON`);
}
/** @internal */
export const MessageContentFormType$inboundSchema = z.nativeEnum(MessageContentFormType);
/** @internal */
export const MessageContentFormType$outboundSchema = MessageContentFormType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFormType$;
(function (MessageContentFormType$) {
    /** @deprecated use `MessageContentFormType$inboundSchema` instead. */
    MessageContentFormType$.inboundSchema = MessageContentFormType$inboundSchema;
    /** @deprecated use `MessageContentFormType$outboundSchema` instead. */
    MessageContentFormType$.outboundSchema = MessageContentFormType$outboundSchema;
})(MessageContentFormType$ || (MessageContentFormType$ = {}));
/** @internal */
export const MessageContentFormParameters$inboundSchema = z.object({});
/** @internal */
export const MessageContentFormParameters$outboundSchema = z.object({});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFormParameters$;
(function (MessageContentFormParameters$) {
    /** @deprecated use `MessageContentFormParameters$inboundSchema` instead. */
    MessageContentFormParameters$.inboundSchema = MessageContentFormParameters$inboundSchema;
    /** @deprecated use `MessageContentFormParameters$outboundSchema` instead. */
    MessageContentFormParameters$.outboundSchema = MessageContentFormParameters$outboundSchema;
})(MessageContentFormParameters$ || (MessageContentFormParameters$ = {}));
export function messageContentFormParametersToJSON(messageContentFormParameters) {
    return JSON.stringify(MessageContentFormParameters$outboundSchema.parse(messageContentFormParameters));
}
export function messageContentFormParametersFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentFormParameters$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentFormParameters' from JSON`);
}
/** @internal */
export const MessageContentForm$inboundSchema = z.object({
    type: MessageContentFormType$inboundSchema,
    formSchema: z.string(),
    callId: z.string(),
    functionName: z.string().optional(),
    parameters: z.lazy(() => MessageContentFormParameters$inboundSchema),
});
/** @internal */
export const MessageContentForm$outboundSchema = z.object({
    type: MessageContentFormType$outboundSchema,
    formSchema: z.string(),
    callId: z.string(),
    functionName: z.string().optional(),
    parameters: z.lazy(() => MessageContentFormParameters$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentForm$;
(function (MessageContentForm$) {
    /** @deprecated use `MessageContentForm$inboundSchema` instead. */
    MessageContentForm$.inboundSchema = MessageContentForm$inboundSchema;
    /** @deprecated use `MessageContentForm$outboundSchema` instead. */
    MessageContentForm$.outboundSchema = MessageContentForm$outboundSchema;
})(MessageContentForm$ || (MessageContentForm$ = {}));
export function messageContentFormToJSON(messageContentForm) {
    return JSON.stringify(MessageContentForm$outboundSchema.parse(messageContentForm));
}
export function messageContentFormFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentForm$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentForm' from JSON`);
}
/** @internal */
export const MessageContentBarChartType$inboundSchema = z.nativeEnum(MessageContentBarChartType);
/** @internal */
export const MessageContentBarChartType$outboundSchema = MessageContentBarChartType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentBarChartType$;
(function (MessageContentBarChartType$) {
    /** @deprecated use `MessageContentBarChartType$inboundSchema` instead. */
    MessageContentBarChartType$.inboundSchema = MessageContentBarChartType$inboundSchema;
    /** @deprecated use `MessageContentBarChartType$outboundSchema` instead. */
    MessageContentBarChartType$.outboundSchema = MessageContentBarChartType$outboundSchema;
})(MessageContentBarChartType$ || (MessageContentBarChartType$ = {}));
/** @internal */
export const Data$inboundSchema = z
    .object({
    label: z.string(),
    value: z.number(),
    group: z.nullable(z.string()).optional(),
});
/** @internal */
export const Data$outboundSchema = z.object({
    label: z.string(),
    value: z.number(),
    group: z.nullable(z.string()).optional(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var Data$;
(function (Data$) {
    /** @deprecated use `Data$inboundSchema` instead. */
    Data$.inboundSchema = Data$inboundSchema;
    /** @deprecated use `Data$outboundSchema` instead. */
    Data$.outboundSchema = Data$outboundSchema;
})(Data$ || (Data$ = {}));
export function dataToJSON(data) {
    return JSON.stringify(Data$outboundSchema.parse(data));
}
export function dataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => Data$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Data' from JSON`);
}
/** @internal */
export const Chart$inboundSchema = z
    .object({
    title: z.string(),
    data: z.array(z.lazy(() => Data$inboundSchema)),
});
/** @internal */
export const Chart$outboundSchema = z.object({
    title: z.string(),
    data: z.array(z.lazy(() => Data$outboundSchema)),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var Chart$;
(function (Chart$) {
    /** @deprecated use `Chart$inboundSchema` instead. */
    Chart$.inboundSchema = Chart$inboundSchema;
    /** @deprecated use `Chart$outboundSchema` instead. */
    Chart$.outboundSchema = Chart$outboundSchema;
})(Chart$ || (Chart$ = {}));
export function chartToJSON(chart) {
    return JSON.stringify(Chart$outboundSchema.parse(chart));
}
export function chartFromJSON(jsonString) {
    return safeParse(jsonString, (x) => Chart$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Chart' from JSON`);
}
/** @internal */
export const MessageContentBarChartParameters$inboundSchema = z.object({});
/** @internal */
export const MessageContentBarChartParameters$outboundSchema = z.object({});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentBarChartParameters$;
(function (MessageContentBarChartParameters$) {
    /** @deprecated use `MessageContentBarChartParameters$inboundSchema` instead. */
    MessageContentBarChartParameters$.inboundSchema = MessageContentBarChartParameters$inboundSchema;
    /** @deprecated use `MessageContentBarChartParameters$outboundSchema` instead. */
    MessageContentBarChartParameters$.outboundSchema = MessageContentBarChartParameters$outboundSchema;
})(MessageContentBarChartParameters$ || (MessageContentBarChartParameters$ = {}));
export function messageContentBarChartParametersToJSON(messageContentBarChartParameters) {
    return JSON.stringify(MessageContentBarChartParameters$outboundSchema.parse(messageContentBarChartParameters));
}
export function messageContentBarChartParametersFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentBarChartParameters$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentBarChartParameters' from JSON`);
}
/** @internal */
export const MessageContentBarChart$inboundSchema = z.object({
    type: MessageContentBarChartType$inboundSchema,
    chart: z.lazy(() => Chart$inboundSchema),
    callId: z.string(),
    functionName: z.string().optional(),
    parameters: z.lazy(() => MessageContentBarChartParameters$inboundSchema),
});
/** @internal */
export const MessageContentBarChart$outboundSchema = z.object({
    type: MessageContentBarChartType$outboundSchema,
    chart: z.lazy(() => Chart$outboundSchema),
    callId: z.string(),
    functionName: z.string().optional(),
    parameters: z.lazy(() => MessageContentBarChartParameters$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentBarChart$;
(function (MessageContentBarChart$) {
    /** @deprecated use `MessageContentBarChart$inboundSchema` instead. */
    MessageContentBarChart$.inboundSchema = MessageContentBarChart$inboundSchema;
    /** @deprecated use `MessageContentBarChart$outboundSchema` instead. */
    MessageContentBarChart$.outboundSchema = MessageContentBarChart$outboundSchema;
})(MessageContentBarChart$ || (MessageContentBarChart$ = {}));
export function messageContentBarChartToJSON(messageContentBarChart) {
    return JSON.stringify(MessageContentBarChart$outboundSchema.parse(messageContentBarChart));
}
export function messageContentBarChartFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentBarChart$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentBarChart' from JSON`);
}
/** @internal */
export const MessageContentTextType$inboundSchema = z.nativeEnum(MessageContentTextType);
/** @internal */
export const MessageContentTextType$outboundSchema = MessageContentTextType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentTextType$;
(function (MessageContentTextType$) {
    /** @deprecated use `MessageContentTextType$inboundSchema` instead. */
    MessageContentTextType$.inboundSchema = MessageContentTextType$inboundSchema;
    /** @deprecated use `MessageContentTextType$outboundSchema` instead. */
    MessageContentTextType$.outboundSchema = MessageContentTextType$outboundSchema;
})(MessageContentTextType$ || (MessageContentTextType$ = {}));
/** @internal */
export const MessageContentText$inboundSchema = z.object({
    type: MessageContentTextType$inboundSchema,
    content: z.string(),
});
/** @internal */
export const MessageContentText$outboundSchema = z.object({
    type: MessageContentTextType$outboundSchema,
    content: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentText$;
(function (MessageContentText$) {
    /** @deprecated use `MessageContentText$inboundSchema` instead. */
    MessageContentText$.inboundSchema = MessageContentText$inboundSchema;
    /** @deprecated use `MessageContentText$outboundSchema` instead. */
    MessageContentText$.outboundSchema = MessageContentText$outboundSchema;
})(MessageContentText$ || (MessageContentText$ = {}));
export function messageContentTextToJSON(messageContentText) {
    return JSON.stringify(MessageContentText$outboundSchema.parse(messageContentText));
}
export function messageContentTextFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentText$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentText' from JSON`);
}
/** @internal */
export const MessageContentFunctionResultType$inboundSchema = z.nativeEnum(MessageContentFunctionResultType);
/** @internal */
export const MessageContentFunctionResultType$outboundSchema = MessageContentFunctionResultType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFunctionResultType$;
(function (MessageContentFunctionResultType$) {
    /** @deprecated use `MessageContentFunctionResultType$inboundSchema` instead. */
    MessageContentFunctionResultType$.inboundSchema = MessageContentFunctionResultType$inboundSchema;
    /** @deprecated use `MessageContentFunctionResultType$outboundSchema` instead. */
    MessageContentFunctionResultType$.outboundSchema = MessageContentFunctionResultType$outboundSchema;
})(MessageContentFunctionResultType$ || (MessageContentFunctionResultType$ = {}));
/** @internal */
export const MessageContentFunctionResult$inboundSchema = z.object({
    type: MessageContentFunctionResultType$inboundSchema,
    callId: z.string(),
    functionName: z.string(),
    result: z.any().optional(),
});
/** @internal */
export const MessageContentFunctionResult$outboundSchema = z.object({
    type: MessageContentFunctionResultType$outboundSchema,
    callId: z.string(),
    functionName: z.string(),
    result: z.any().optional(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFunctionResult$;
(function (MessageContentFunctionResult$) {
    /** @deprecated use `MessageContentFunctionResult$inboundSchema` instead. */
    MessageContentFunctionResult$.inboundSchema = MessageContentFunctionResult$inboundSchema;
    /** @deprecated use `MessageContentFunctionResult$outboundSchema` instead. */
    MessageContentFunctionResult$.outboundSchema = MessageContentFunctionResult$outboundSchema;
})(MessageContentFunctionResult$ || (MessageContentFunctionResult$ = {}));
export function messageContentFunctionResultToJSON(messageContentFunctionResult) {
    return JSON.stringify(MessageContentFunctionResult$outboundSchema.parse(messageContentFunctionResult));
}
export function messageContentFunctionResultFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentFunctionResult$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentFunctionResult' from JSON`);
}
/** @internal */
export const MessageContentFunctionCallType$inboundSchema = z.nativeEnum(MessageContentFunctionCallType);
/** @internal */
export const MessageContentFunctionCallType$outboundSchema = MessageContentFunctionCallType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFunctionCallType$;
(function (MessageContentFunctionCallType$) {
    /** @deprecated use `MessageContentFunctionCallType$inboundSchema` instead. */
    MessageContentFunctionCallType$.inboundSchema = MessageContentFunctionCallType$inboundSchema;
    /** @deprecated use `MessageContentFunctionCallType$outboundSchema` instead. */
    MessageContentFunctionCallType$.outboundSchema = MessageContentFunctionCallType$outboundSchema;
})(MessageContentFunctionCallType$ || (MessageContentFunctionCallType$ = {}));
/** @internal */
export const ParametersT$inboundSchema = z.object({});
/** @internal */
export const ParametersT$outboundSchema = z.object({});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var ParametersT$;
(function (ParametersT$) {
    /** @deprecated use `ParametersT$inboundSchema` instead. */
    ParametersT$.inboundSchema = ParametersT$inboundSchema;
    /** @deprecated use `ParametersT$outboundSchema` instead. */
    ParametersT$.outboundSchema = ParametersT$outboundSchema;
})(ParametersT$ || (ParametersT$ = {}));
export function parametersToJSON(parametersT) {
    return JSON.stringify(ParametersT$outboundSchema.parse(parametersT));
}
export function parametersFromJSON(jsonString) {
    return safeParse(jsonString, (x) => ParametersT$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ParametersT' from JSON`);
}
/** @internal */
export const MessageContentFunctionCall$inboundSchema = z.object({
    type: MessageContentFunctionCallType$inboundSchema,
    callId: z.string(),
    functionName: z.string(),
    parameters: z.lazy(() => ParametersT$inboundSchema),
});
/** @internal */
export const MessageContentFunctionCall$outboundSchema = z.object({
    type: MessageContentFunctionCallType$outboundSchema,
    callId: z.string(),
    functionName: z.string(),
    parameters: z.lazy(() => ParametersT$outboundSchema),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentFunctionCall$;
(function (MessageContentFunctionCall$) {
    /** @deprecated use `MessageContentFunctionCall$inboundSchema` instead. */
    MessageContentFunctionCall$.inboundSchema = MessageContentFunctionCall$inboundSchema;
    /** @deprecated use `MessageContentFunctionCall$outboundSchema` instead. */
    MessageContentFunctionCall$.outboundSchema = MessageContentFunctionCall$outboundSchema;
})(MessageContentFunctionCall$ || (MessageContentFunctionCall$ = {}));
export function messageContentFunctionCallToJSON(messageContentFunctionCall) {
    return JSON.stringify(MessageContentFunctionCall$outboundSchema.parse(messageContentFunctionCall));
}
export function messageContentFunctionCallFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentFunctionCall$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentFunctionCall' from JSON`);
}
/** @internal */
export const MessageContentBinaryType$inboundSchema = z.nativeEnum(MessageContentBinaryType);
/** @internal */
export const MessageContentBinaryType$outboundSchema = MessageContentBinaryType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentBinaryType$;
(function (MessageContentBinaryType$) {
    /** @deprecated use `MessageContentBinaryType$inboundSchema` instead. */
    MessageContentBinaryType$.inboundSchema = MessageContentBinaryType$inboundSchema;
    /** @deprecated use `MessageContentBinaryType$outboundSchema` instead. */
    MessageContentBinaryType$.outboundSchema = MessageContentBinaryType$outboundSchema;
})(MessageContentBinaryType$ || (MessageContentBinaryType$ = {}));
/** @internal */
export const MessageContentBinary$inboundSchema = z.object({
    type: MessageContentBinaryType$inboundSchema,
    data: z.string(),
    mimeType: z.string(),
});
/** @internal */
export const MessageContentBinary$outboundSchema = z.object({
    type: MessageContentBinaryType$outboundSchema,
    data: z.string(),
    mimeType: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentBinary$;
(function (MessageContentBinary$) {
    /** @deprecated use `MessageContentBinary$inboundSchema` instead. */
    MessageContentBinary$.inboundSchema = MessageContentBinary$inboundSchema;
    /** @deprecated use `MessageContentBinary$outboundSchema` instead. */
    MessageContentBinary$.outboundSchema = MessageContentBinary$outboundSchema;
})(MessageContentBinary$ || (MessageContentBinary$ = {}));
export function messageContentBinaryToJSON(messageContentBinary) {
    return JSON.stringify(MessageContentBinary$outboundSchema.parse(messageContentBinary));
}
export function messageContentBinaryFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentBinary$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentBinary' from JSON`);
}
/** @internal */
export const MessageContentMetadataType$inboundSchema = z.nativeEnum(MessageContentMetadataType);
/** @internal */
export const MessageContentMetadataType$outboundSchema = MessageContentMetadataType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentMetadataType$;
(function (MessageContentMetadataType$) {
    /** @deprecated use `MessageContentMetadataType$inboundSchema` instead. */
    MessageContentMetadataType$.inboundSchema = MessageContentMetadataType$inboundSchema;
    /** @deprecated use `MessageContentMetadataType$outboundSchema` instead. */
    MessageContentMetadataType$.outboundSchema = MessageContentMetadataType$outboundSchema;
})(MessageContentMetadataType$ || (MessageContentMetadataType$ = {}));
/** @internal */
export const MessageContentMetadata$inboundSchema = z.object({
    type: MessageContentMetadataType$inboundSchema,
    id: z.string(),
    role: Role$inboundSchema,
    timestamp: z.string().datetime({ offset: true }).transform(v => new Date(v)),
});
/** @internal */
export const MessageContentMetadata$outboundSchema = z.object({
    type: MessageContentMetadataType$outboundSchema,
    id: z.string(),
    role: Role$outboundSchema,
    timestamp: z.date().transform(v => v.toISOString()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContentMetadata$;
(function (MessageContentMetadata$) {
    /** @deprecated use `MessageContentMetadata$inboundSchema` instead. */
    MessageContentMetadata$.inboundSchema = MessageContentMetadata$inboundSchema;
    /** @deprecated use `MessageContentMetadata$outboundSchema` instead. */
    MessageContentMetadata$.outboundSchema = MessageContentMetadata$outboundSchema;
})(MessageContentMetadata$ || (MessageContentMetadata$ = {}));
export function messageContentMetadataToJSON(messageContentMetadata) {
    return JSON.stringify(MessageContentMetadata$outboundSchema.parse(messageContentMetadata));
}
export function messageContentMetadataFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContentMetadata$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContentMetadata' from JSON`);
}
/** @internal */
export const MessageContent$inboundSchema = z.union([
    z.lazy(() => MessageContentText$inboundSchema).and(z.object({ type: z.literal("text") }).transform((v) => ({ type: v.type }))),
    z.lazy(() => MessageContentBinary$inboundSchema).and(z.object({ type: z.literal("binary") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentMetadata$inboundSchema).and(z.object({ type: z.literal("metadata") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentFunctionCall$inboundSchema).and(z.object({ type: z.literal("function_call") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentFunctionResult$inboundSchema).and(z.object({ type: z.literal("function_result") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentFormSubmission$inboundSchema).and(z.object({ type: z.literal("form_submission") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentBarChart$inboundSchema).and(z.object({ type: z.literal("bar_chart") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentForm$inboundSchema).and(z.object({ type: z.literal("form") }).transform((v) => ({ type: v.type }))),
    z.lazy(() => MessageContentPieChart$inboundSchema).and(z.object({ type: z.literal("pie_chart") }).transform((v) => ({
        type: v.type,
    }))),
]);
/** @internal */
export const MessageContent$outboundSchema = z.union([
    z.lazy(() => MessageContentText$outboundSchema).and(z.object({ type: z.literal("text") }).transform((v) => ({ type: v.type }))),
    z.lazy(() => MessageContentBinary$outboundSchema).and(z.object({ type: z.literal("binary") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentMetadata$outboundSchema).and(z.object({ type: z.literal("metadata") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentFunctionCall$outboundSchema).and(z.object({ type: z.literal("function_call") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentFunctionResult$outboundSchema).and(z.object({ type: z.literal("function_result") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentFormSubmission$outboundSchema).and(z.object({ type: z.literal("form_submission") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentBarChart$outboundSchema).and(z.object({ type: z.literal("bar_chart") }).transform((v) => ({
        type: v.type,
    }))),
    z.lazy(() => MessageContentForm$outboundSchema).and(z.object({ type: z.literal("form") }).transform((v) => ({ type: v.type }))),
    z.lazy(() => MessageContentPieChart$outboundSchema).and(z.object({ type: z.literal("pie_chart") }).transform((v) => ({
        type: v.type,
    }))),
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var MessageContent$;
(function (MessageContent$) {
    /** @deprecated use `MessageContent$inboundSchema` instead. */
    MessageContent$.inboundSchema = MessageContent$inboundSchema;
    /** @deprecated use `MessageContent$outboundSchema` instead. */
    MessageContent$.outboundSchema = MessageContent$outboundSchema;
})(MessageContent$ || (MessageContent$ = {}));
export function messageContentToJSON(messageContent) {
    return JSON.stringify(MessageContent$outboundSchema.parse(messageContent));
}
export function messageContentFromJSON(jsonString) {
    return safeParse(jsonString, (x) => MessageContent$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MessageContent' from JSON`);
}
//# sourceMappingURL=messagecontent.js.map